import React from 'react';
import { Modal, Input, Empty } from 'antd';
import { Search, CornerDownLeft } from 'lucide-react';
import { useCommandPalette } from './sidebar.controller';

/** ⌘K page switcher. View only — state lives in useCommandPalette. */
export default function CommandPalette(props) {
    const palette = useCommandPalette(props);
    if (!palette.open) return null;

    return (
        <Modal
            open
            onCancel={palette.close}
            footer={null}
            closable={false}
            centered
            width={560}
            destroyOnClose
            keyboard
            styles={{
                content: { padding: 0, overflow: 'hidden' },
                mask: { backdropFilter: 'blur(2px)', background: 'rgba(17, 22, 32, 0.35)' }
            }}>
            <div className="flex items-center gap-3 px-4 h-14 border-b border-surface-200">
                <Search className="text-surface-400 text-[17px]" />
                <Input
                    autoFocus
                    variant="borderless"
                    placeholder="Ir a una página…"
                    value={palette.searchTerm}
                    onChange={(e) => palette.setSearchTerm(e.target.value)}
                    onKeyDown={palette.onKeyDown}
                    className="!px-0 text-[15px]"
                    allowClear
                />
            </div>

            <div className="max-h-[360px] overflow-y-auto p-2">
                {palette.items.length === 0 ? (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No se encontraron páginas" className="py-8" />
                ) : (
                    palette.items.map((item, index) => {
                        const active = index === palette.selectedIndex;
                        return (
                            <button
                                key={item.key}
                                type="button"
                                onClick={() => palette.select(item)}
                                onMouseEnter={() => palette.setSelectedIndex(index)}
                                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left transition-colors ${
                                    active ? 'bg-primary-50' : 'hover:bg-surface-50'
                                }`}>
                                <span
                                    className={`w-8 h-8 rounded-md flex items-center justify-center shrink-0 [&_svg]:w-4 ${
                                        active ? 'bg-white text-primary-600 shadow-xs' : 'bg-surface-100 text-surface-500'
                                    }`}>
                                    {item.icon}
                                </span>
                                <span className="flex-1 min-w-0">
                                    <span className={`block text-sm font-medium ${active ? 'text-primary-700' : 'text-surface-900'}`}>
                                        {item.label}
                                    </span>
                                    <span className="block text-xs text-surface-500 truncate">{item.description}</span>
                                </span>
                                {active && <CornerDownLeft className="text-primary-500 text-sm" />}
                            </button>
                        );
                    })
                )}
            </div>

            <div className="px-4 h-10 border-t border-surface-200 bg-surface-50 flex items-center gap-4 text-xs text-surface-500">
                <span className="flex items-center gap-1.5">
                    <kbd className="kbd">↑</kbd>
                    <kbd className="kbd">↓</kbd>
                    Navegar
                </span>
                <span className="flex items-center gap-1.5">
                    <kbd className="kbd">Enter</kbd>
                    Abrir
                </span>
                <span className="flex items-center gap-1.5">
                    <kbd className="kbd">Esc</kbd>
                    Cerrar
                </span>
            </div>
        </Modal>
    );
}
